export default {"src":"/_next/static/media/WhoWeAre_018A.f1e1e7fd.JPG","height":708,"width":1920};